package com.macrofocus.eflux.components

import js.objects.unsafeJso
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import react.FC
import react.Props
import react.useRequired
import web.cssom.Auto
import web.cssom.Position
import web.cssom.px

val SecondaryInfo = FC<Props> {
    val context = useRequired(EFluxContext)
    val theme = useTheme<Theme>()

    val customBackground: (SxProps<Theme>) -> Unit = { it ->
        it.blurBackground(theme)
    }

    Paper {
        sx = unsafeJso {
            position = Position.relative
            top = 0.px
//                    bottom = 0.px
            height = Auto.auto
            left = 0.px
            right = 0.px

            customBackground(this)
        }

        Info {
            primary = false
            probing = context.dataLoader.controller.secondaryProbing
            selection = context.dataLoader.controller.secondarySelection
        }
    }
}